import React from 'react';
import webapi from '../../../api/webapi';
import Header from '../Header/Header'
import Footer from '../Footer/Footer'


class Book extends React.Component {
    state = { statments : [] }
    state = { LanguageInfo: [{Code:"fa",Title:"فارسی",Direction:"rtl"}] }

    constructor(props, context) {
        super(props, context);
        this.state = {
            pageData: undefined
        };
    }
    
    componentDidMount() {
        if (new URLSearchParams(this.props.location.search).get("lang")!=null)
        {
            //console.log('LangFromURL: ',new URLSearchParams(this.props.location.search).get("lang"));
            //console.log('LangFromSubDomain: ',window.location.host.split(".")[0]);
            this.getLanguageInfo(new URLSearchParams(this.props.location.search).get("lang"));
            //console.log(this.state.LanguageInfo);
        }else{
            this.setState({LanguageInfo: [{Code:"fa",Title:"فارسی",Direction:"rtl"}]});
            document.getElementsByTagName('html')[0].setAttribute("lang","Fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
            this.getPage();
        }

        //this.getPage();
        //fetch('https://api.ipify.org/?format=json')
        // fetch('https://geolocation-db.com/json/')
        //     .then(response => {
        //         return response.json();
        //     }, "jsonp")
        //     .then(res => {
        //         this.setLog('pages/log/book_'+this.props.match.params.bookcode+'/visit/'+res.IPv4.replaceAll('.',','))
        //     })
        //     .catch(err => this.setLog('pages/log/book_'+this.props.match.params.bookcode+'/visit/'+err));
    }

    async getLanguageInfo(LanguageCode){
        const responseResultlanguageinfo = await webapi.get('pages/LanguageInfo/'+LanguageCode);
        //console.log(responseResultlanguageinfo.data.length);
        //console.log(responseResultlanguageinfo.data);
        
        if (responseResultlanguageinfo!==undefined && responseResultlanguageinfo.data.length>0)
        {
            this.setState({LanguageInfo:responseResultlanguageinfo.data});
            //this.setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang", responseResultlanguageinfo.data[0].Code);
            document.getElementsByTagName('html')[0].setAttribute("dir", responseResultlanguageinfo.data[0].Direction);
        }
        else
        {
            this.setState({LanguageInfo: [{Code:"fa",Title:"فارسی",Direction:"rtl"}]});
            //this.setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang","fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
        }
        this.getPage();
    }

    async getPage() {
        if (this.state.LanguageInfo)
        {
            const pageList = await webapi.get('pages/datapages/201/'+this.state.LanguageInfo[0].Code);
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }else{
            const pageList = await webapi.get('pages/datapages/201/fa');
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }

        const BookDataConst = await webapi.get('book/bookdetaildata/'+this.props.match.params.bookcode+'/'+this.state.LanguageInfo[0].Code);   
        //console.log(BookDataConst);     
        this.setState({
            BookData: BookDataConst.data
        });
        const BookHtmlConst = await webapi.get('book/bookdetailhtml/'+this.props.match.params.bookcode+'/'+this.state.LanguageInfo[0].Code);   
        //console.log(BookHtmlConst);     
        this.setState({
            BookHtml: BookHtmlConst.data
        });
    }

    async setLog(Data) {
        await webapi.post(Data);
    }
    
    render() {
        if (this.state.pageData && this.state.LanguageInfo) {
            return  (
                <div>
                    <Header LanguageInfo = {this.state.LanguageInfo}/>
                    <div className="container-fluid" id="innerpage_row_1">
                        <div className="container">
                            <h1 id="page_title">
                                {
                                    (this.state.BookData)
                                    ?
                                    this.state.BookData[0].Title
                                    :
                                    null
                                }
                            </h1>
                        </div>
                    </div>
                    <div className="container-fluid">
                            <div className="container container_70">
                    {
                        (this.state.BookHtml)
                        ?
                        <div>
                            <div key={this.state.BookHtml[0].Code}>
                                {/* <img alt={this.state.Books[0].Title} className="book_img" src= {"data:image/png;base64,"+this.state.Books[0].Logo} style={{float:"right",margin:"10px"}}/> */}
                                {/* <p className="book_title"> {this.state.Books[0].Title}</p> */}
                                <section
                                    className="book_summary"
                                    dangerouslySetInnerHTML={{__html:this.state.BookHtml[0].Note}}                                    
                                />
                                {/* <p className="book_stat">{this.state.Books[0].Description}</p>
                                <p className="book_number"><span className="circle">{this.state.Books[0].Field2}</span></p> */}
                            </div>
                        </div>
                        :
                        <div style={{height:"400px",width:"100%", clear:"both"}}></div>
                    }
                    </div>
                    </div>
                    <Footer Lang = {this.state.LanguageInfo[0].Code}/>
                </div>  
            )
        }
        else
        {
            return (
                <div></div>
            )
        }
    }
 }

 export default Book;